import { apiClient } from "./apiClient";

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  avatar?: string;
  message: string;
}

export interface RegisterRequest {
  username: string;
  password: string;
  email: string;
  firstname: string;
  lastname: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  userId: number;
  token: string;
  newPassword: string;
}

export interface ResendVerificationRequest {
  Email: string;
}

export const authAPI = {
  login: async (credentials: LoginRequest) => {
    try {
      const response = await apiClient.post<LoginResponse>("/users/login", credentials);
      return response;
    } catch (error) {
      throw error;
    }
  },
  register: async (userData: RegisterRequest) => {
    try {
      const response = await apiClient.post<RegisterRequest>("/users/register", userData);
      return response;
    } catch (error) {
      throw error;
    }
  },
  forgotPassword: async (data: ForgotPasswordRequest) => {
    return await apiClient.post<{ message: string }>("/auth/forgot-password", data);
  },
  resetPassword: async (data: ResetPasswordRequest) => {
    return await apiClient.post<{ message: string }>("/auth/reset-password", data);
  },
  resendVerification: async (data: ResendVerificationRequest) => {
    return await apiClient.post<{ message: string }>("/auth/resend-verification", data);
  },
  logout: async () => {
    return await apiClient.post<{ message: string }>("/users/logout");
  },
};
